import React from 'react';
import { useSelector } from 'react-redux';
import { CROP_ALIGNMENT } from '@/constants';
import { CropIcon } from '@/components';
import { getSelectedSection } from '@/helpers';

const EditControls = () => {
  const scaleCoef = useSelector(state => state.core.scaleCoef);
  const floatableInputVisible = useSelector(state => state.core.floatableInputVisible);
  const sectionsSelection = useSelector(state => state.core.sectionsSelection);
  const pages = useSelector(state => state.core.pages);
  const isEditModeEnabled = floatableInputVisible;
  const selectedSection = getSelectedSection({ sectionsSelection, pages });
  const isSectionEdit = isEditModeEnabled && !!selectedSection;

  if (isSectionEdit) {
    const rectProps = { x: selectedSection.x, y: selectedSection.y, width: selectedSection.width, height: selectedSection.height };
    const offset = 4 / scaleCoef;
    const widthWithScale = 30 / scaleCoef;
    const heightWithScale = 30 / scaleCoef;
    const heightExceeding = heightWithScale * 2 >= rectProps.height;
    const widthExceeding = widthWithScale * 2 >= rectProps.width;
    const exceeding = heightExceeding || widthExceeding;
    const width = exceeding ? (widthExceeding ? rectProps.width / 3 : rectProps.height / 3) : widthWithScale;
    const height = exceeding ? (widthExceeding ? rectProps.width / 3 : rectProps.height / 3) : heightWithScale;
    const topLeftX = rectProps.x + offset;
    const topLeftY = rectProps.y + offset;
    const topRightX = rectProps.x + rectProps.width - width - offset;
    const topRightY = rectProps.y + offset;
    const bottomLeftX = rectProps.x + offset;
    const bottomLeftY = rectProps.y + rectProps.height - height - offset;
    const bottomRightX = rectProps.x + rectProps.width - width - offset;
    const bottomRightY = rectProps.y + rectProps.height - height - offset;
  
    return (
      <>
        <CropIcon alignment={CROP_ALIGNMENT.TOP_LEFT} x={topLeftX} y={topLeftY} width={width} height={height} />
        <CropIcon alignment={CROP_ALIGNMENT.TOP_RIGHT} x={topRightX} y={topRightY} width={width} height={height} />
        <CropIcon alignment={CROP_ALIGNMENT.BOTTOM_LEFT} x={bottomLeftX} y={bottomLeftY} width={width} height={height} />
        <CropIcon alignment={CROP_ALIGNMENT.BOTTOM_RIGHT} x={bottomRightX} y={bottomRightY} width={width} height={height} />
      </>
    );
  }
  return null;
};

export default EditControls;